// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --light-yellow-bg: #fbf4dd;
  --light-yellow-color: #a37f08;
  --light-yellow-border: #a37f08;

  --light-red-bg: #ffeeeb;
  --light-red-color: #db5436;
  --light-red-border: #db5436;

  --light-green-bg: #eaf9e6;
  --light-green-color: #4d8f3a;
  --light-green-border: #4d8f3a;

  --light-blue-bg: #ebf5ff;
  --light-blue-color: #1f7eeb;
  --light-blue-border: #1f7eeb;

  --light-purpule-bg: #eee7fc;
  --light-purpule-color: #7038db;
  --light-purpule-border: #7038db;
}

body {
  font-family: "DM Sans", sans-serif;
}

option {
  color: black;
}

* {
  letter-spacing: 0.3px;
  outline: none;
}

::-webkit-scrollbar {
  height: 4px !important;
  width: 7px;
}

::-webkit-scrollbar-thumb {
  background: #b9b9b9;
  border-radius: 20px;
}

.css-70fard,
.apexcharts-toolbar {
  z-index: 0 !important;
}

.fc-bg-event {
  opacity: 1 !important;
}

.p0 {
  margin-top: 0;
}

/* TABLE  */
.table-container {
  min-height: 23vh;
  max-height: 23vh;
  overflow-y: auto;
}

.table-container thead {
  border-bottom: 1px solid black;
  box-shadow: -2px 0px 4px -2px #5c5d5efa;
  position: sticky;
  top: 0;
  height: 25px;
  background: #ffffff;
}

.table-container-property {
  min-height: auto;
  max-height: 68vh;
  overflow-y: auto;
}

.css-efk3t2 {
  max-height: 15rem !important;
  overflow-y: scroll !important;
}

.table-container-property thead {
  position: sticky;
  top: 0;
  height: 25px;
  background: #ffffff;
  border-bottom: 1px solid black;
  box-shadow: -2px 0px 4px -2px #5c5d5efa;
}

.table-fix-container {
  min-height: 63vh;
  max-height: 63vh;
  overflow-y: auto;
}

.small-table-fix-container {
  min-height: 15vh;
  max-height: 63vh;
  overflow-y: auto;
}

.table-fix-container thead {
  border-bottom: 1px solid black;
  box-shadow: -2px 0px 4px -2px #5c5d5efa;
  position: sticky;
  top: 0;
  height: 25px;
  background: #ffffff;
}

.importTable {
  min-height: auto;
  max-height: 82vh;
  overflow-y: auto;
}

.tableData {
  padding: 10px !important;
}

/* .leadRow td {
  border-bottom: 1px solid #e2e8f0;
} */

.datePickerBorder {
  border: 1px solid #e2e8f0;
  padding: 0 5px;
  border-radius: 5px;
  margin: 0 10px !important;
}

.imageCard {
  position: relative;
  overflow: hidden;
  margin-right: 12px;
  /* height: 200px;
  width: 400px; */
}

.imageContent {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  background-color: #00000096;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
}

.imageCard:hover .imageContent {
  opacity: 1;
}

.EditDelete {
  display: none;
}

.CustomFieldName {
  border-bottom: 1px solid rgba(128, 128, 128, 0.705);
}

.CustomFieldName:hover .EditDelete {
  display: block;
}

.pending {
  background-color: var(--light-yellow-bg) !important;
  color: var(--light-yellow-color) !important;
  border: 1px solid var(--light-yellow-border) !important;
}

.onHold {
  background-color: var(--light-red-bg) !important;
  color: var(--light-red-color) !important;
  border: 1px solid var(--light-red-border) !important;
}

.completed {
  background-color: var(--light-green-bg) !important;
  color: var(--light-green-color) !important;
  border: 1px solid var(--light-green-border) !important;
}

.toDo {
  background-color: var(--light-blue-bg) !important;
  color: var(--light-blue-color) !important;
  border: 1px solid var(--light-blue-border) !important;
}

.inProgress {
  background-color: var(--light-purpule-bg) !important;
  color: var(--light-purpule-color) !important;
  border: 1px solid var(--light-purpule-border) !important;
}

.light-yellow {
  background-color: var(--light-yellow-bg) !important;
  color: var(--light-yellow-color) !important;
  border: 1px solid var(--light-yellow-border) !important;
}

.light-red {
  background-color: var(--light-red-bg) !important;
  color: var(--light-red-color) !important;
  border: 1px solid var(--light-red-border) !important;
}

.light-green {
  background-color: var(--light-green-bg) !important;
  color: var(--light-green-color) !important;
  border: 1px solid var(--light-green-border) !important;
}

.light-blue {
  background-color: var(--light-blue-bg) !important;
  color: var(--light-blue-color) !important;
  border: 1px solid var(--light-blue-border) !important;
}

.light-purpule {
  background-color: var(--light-purpule-bg) !important;
  color: var(--light-purpule-color) !important;
  border: 1px solid var(--light-purpule-border) !important;
}

.chakra-checkbox[disabled] .chakra-checkbox__control {
  background-color: #dcdee0 !important;
  border: 2px solid #d1d1d1;
}

/* Invoice.css */
.invoice-container {
  width: 100%;
  margin: 20px auto;
  padding: 20px;
  border: 1px solid #000;
  font-family: Arial, sans-serif;
  font-size: 14px;
}
.invoice-container2 {
  width: 50%;
  margin: 20px auto;
  padding: 20px;
  border: 1px solid #000;
  font-family: Arial, sans-serif;
  font-size: 14px;
}

.invoice-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  font-weight: bold;
  font-size: 24px;
  color: orange;
}

.invoice-details {
  text-align: right;
}

.address-section {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

.address {
  width: 45%;
  margin-top: 20px;
}

.invoice-info {
  margin-top: 20px;
}

.invoice-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.invoice-table th,
.invoice-table td {
  border: 1px solid #000;
  padding: 5px;
  text-align: center;
}

.totals {
  margin-top: 20px;
  display: flex;
  justify-content: end;
}

.totals > div {
  margin-bottom: 5px;
}

.net-amount {
  font-weight: bold;
}

.footer {
  margin-top: 20px;
  text-align: center;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/App.css"],"names":[],"mappings":"AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,8BAA8B;;EAE9B,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;;EAE3B,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;;EAE7B,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;;EAE5B,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;GAEG;;AAEH;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;iBACe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mDAAmD;EACnD,2CAA2C;EAC3C,uDAAuD;AACzD;;AAEA;EACE,gDAAgD;EAChD,wCAAwC;EACxC,oDAAoD;AACtD;;AAEA;EACE,kDAAkD;EAClD,0CAA0C;EAC1C,sDAAsD;AACxD;;AAEA;EACE,iDAAiD;EACjD,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,oDAAoD;EACpD,4CAA4C;EAC5C,wDAAwD;AAC1D;;AAEA;EACE,mDAAmD;EACnD,2CAA2C;EAC3C,uDAAuD;AACzD;;AAEA;EACE,gDAAgD;EAChD,wCAAwC;EACxC,oDAAoD;AACtD;;AAEA;EACE,kDAAkD;EAClD,0CAA0C;EAC1C,sDAAsD;AACxD;;AAEA;EACE,iDAAiD;EACjD,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,oDAAoD;EACpD,4CAA4C;EAC5C,wDAAwD;AAC1D;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap\");\n\n:root {\n  --light-yellow-bg: #fbf4dd;\n  --light-yellow-color: #a37f08;\n  --light-yellow-border: #a37f08;\n\n  --light-red-bg: #ffeeeb;\n  --light-red-color: #db5436;\n  --light-red-border: #db5436;\n\n  --light-green-bg: #eaf9e6;\n  --light-green-color: #4d8f3a;\n  --light-green-border: #4d8f3a;\n\n  --light-blue-bg: #ebf5ff;\n  --light-blue-color: #1f7eeb;\n  --light-blue-border: #1f7eeb;\n\n  --light-purpule-bg: #eee7fc;\n  --light-purpule-color: #7038db;\n  --light-purpule-border: #7038db;\n}\n\nbody {\n  font-family: \"DM Sans\", sans-serif;\n}\n\noption {\n  color: black;\n}\n\n* {\n  letter-spacing: 0.3px;\n  outline: none;\n}\n\n::-webkit-scrollbar {\n  height: 4px !important;\n  width: 7px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #b9b9b9;\n  border-radius: 20px;\n}\n\n.css-70fard,\n.apexcharts-toolbar {\n  z-index: 0 !important;\n}\n\n.fc-bg-event {\n  opacity: 1 !important;\n}\n\n.p0 {\n  margin-top: 0;\n}\n\n/* TABLE  */\n.table-container {\n  min-height: 23vh;\n  max-height: 23vh;\n  overflow-y: auto;\n}\n\n.table-container thead {\n  border-bottom: 1px solid black;\n  box-shadow: -2px 0px 4px -2px #5c5d5efa;\n  position: sticky;\n  top: 0;\n  height: 25px;\n  background: #ffffff;\n}\n\n.table-container-property {\n  min-height: auto;\n  max-height: 68vh;\n  overflow-y: auto;\n}\n\n.css-efk3t2 {\n  max-height: 15rem !important;\n  overflow-y: scroll !important;\n}\n\n.table-container-property thead {\n  position: sticky;\n  top: 0;\n  height: 25px;\n  background: #ffffff;\n  border-bottom: 1px solid black;\n  box-shadow: -2px 0px 4px -2px #5c5d5efa;\n}\n\n.table-fix-container {\n  min-height: 63vh;\n  max-height: 63vh;\n  overflow-y: auto;\n}\n\n.small-table-fix-container {\n  min-height: 15vh;\n  max-height: 63vh;\n  overflow-y: auto;\n}\n\n.table-fix-container thead {\n  border-bottom: 1px solid black;\n  box-shadow: -2px 0px 4px -2px #5c5d5efa;\n  position: sticky;\n  top: 0;\n  height: 25px;\n  background: #ffffff;\n}\n\n.importTable {\n  min-height: auto;\n  max-height: 82vh;\n  overflow-y: auto;\n}\n\n.tableData {\n  padding: 10px !important;\n}\n\n/* .leadRow td {\n  border-bottom: 1px solid #e2e8f0;\n} */\n\n.datePickerBorder {\n  border: 1px solid #e2e8f0;\n  padding: 0 5px;\n  border-radius: 5px;\n  margin: 0 10px !important;\n}\n\n.imageCard {\n  position: relative;\n  overflow: hidden;\n  margin-right: 12px;\n  /* height: 200px;\n  width: 400px; */\n}\n\n.imageContent {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: #00000096;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 0;\n}\n\n.imageCard:hover .imageContent {\n  opacity: 1;\n}\n\n.EditDelete {\n  display: none;\n}\n\n.CustomFieldName {\n  border-bottom: 1px solid rgba(128, 128, 128, 0.705);\n}\n\n.CustomFieldName:hover .EditDelete {\n  display: block;\n}\n\n.pending {\n  background-color: var(--light-yellow-bg) !important;\n  color: var(--light-yellow-color) !important;\n  border: 1px solid var(--light-yellow-border) !important;\n}\n\n.onHold {\n  background-color: var(--light-red-bg) !important;\n  color: var(--light-red-color) !important;\n  border: 1px solid var(--light-red-border) !important;\n}\n\n.completed {\n  background-color: var(--light-green-bg) !important;\n  color: var(--light-green-color) !important;\n  border: 1px solid var(--light-green-border) !important;\n}\n\n.toDo {\n  background-color: var(--light-blue-bg) !important;\n  color: var(--light-blue-color) !important;\n  border: 1px solid var(--light-blue-border) !important;\n}\n\n.inProgress {\n  background-color: var(--light-purpule-bg) !important;\n  color: var(--light-purpule-color) !important;\n  border: 1px solid var(--light-purpule-border) !important;\n}\n\n.light-yellow {\n  background-color: var(--light-yellow-bg) !important;\n  color: var(--light-yellow-color) !important;\n  border: 1px solid var(--light-yellow-border) !important;\n}\n\n.light-red {\n  background-color: var(--light-red-bg) !important;\n  color: var(--light-red-color) !important;\n  border: 1px solid var(--light-red-border) !important;\n}\n\n.light-green {\n  background-color: var(--light-green-bg) !important;\n  color: var(--light-green-color) !important;\n  border: 1px solid var(--light-green-border) !important;\n}\n\n.light-blue {\n  background-color: var(--light-blue-bg) !important;\n  color: var(--light-blue-color) !important;\n  border: 1px solid var(--light-blue-border) !important;\n}\n\n.light-purpule {\n  background-color: var(--light-purpule-bg) !important;\n  color: var(--light-purpule-color) !important;\n  border: 1px solid var(--light-purpule-border) !important;\n}\n\n.chakra-checkbox[disabled] .chakra-checkbox__control {\n  background-color: #dcdee0 !important;\n  border: 2px solid #d1d1d1;\n}\n\n/* Invoice.css */\n.invoice-container {\n  width: 100%;\n  margin: 20px auto;\n  padding: 20px;\n  border: 1px solid #000;\n  font-family: Arial, sans-serif;\n  font-size: 14px;\n}\n.invoice-container2 {\n  width: 50%;\n  margin: 20px auto;\n  padding: 20px;\n  border: 1px solid #000;\n  font-family: Arial, sans-serif;\n  font-size: 14px;\n}\n\n.invoice-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.logo {\n  font-weight: bold;\n  font-size: 24px;\n  color: orange;\n}\n\n.invoice-details {\n  text-align: right;\n}\n\n.address-section {\n  margin-top: 20px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.address {\n  width: 45%;\n  margin-top: 20px;\n}\n\n.invoice-info {\n  margin-top: 20px;\n}\n\n.invoice-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\n.invoice-table th,\n.invoice-table td {\n  border: 1px solid #000;\n  padding: 5px;\n  text-align: center;\n}\n\n.totals {\n  margin-top: 20px;\n  display: flex;\n  justify-content: end;\n}\n\n.totals > div {\n  margin-bottom: 5px;\n}\n\n.net-amount {\n  font-weight: bold;\n}\n\n.footer {\n  margin-top: 20px;\n  text-align: center;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
